<template>
    <gofix-card fullContent class="mb-0 pt-20">
        <b-col md="12">
            <b-row>
                <b-col md="3">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Month"
                                :clearable="false"
                                :filterable="false"  
                                fullContent
                                :searchable="false"
                                :options="months"
                                vLabel="text"
                                :reduce="option => option.value"
                                v-model="month">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Year"
                                :clearable="false"
                                :filterable="false" 
                                :searchable="false"
                                :options="years"
                                v-model="year">
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="5">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                v-bind:class="{'run-loading small-loading': loading}"
                                label="Supplier Contract"
                                vLabel="contract_title"
                                @search="searchSupplierContract"
                                :filterable="false"
                                v-model="supplier_contract"
                                :options="supplier_contracts">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown 
                                label="Property Type" 
                                :filterable="false"
                                :clearable="false"
                                :options="property_types" 
                                v-model="property_type"
                                required 
                                show-icon-required>
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="4">
                    <b-row>
                        <b-col md="4" class="text-right pt-15">
                            <!-- <gofix-button label="Interim Report PDF" @click="exportReport()" :disabled="activeExportBtn == false"></gofix-button> -->
                            <!-- <gofix-button class="mr-10" label="Save" @click="saveReport()" :disabled="activeSaveBtn == false"></gofix-button> -->
                        </b-col>
                        <b-col md="8" class="text-left pt-15">
                            <gofix-button class="mr-2" label="Export PDF" @click="exportFinalReport()" :disabled="activeExportBtn == false"></gofix-button>
                            <gofix-button label="Export Excel" @click="exportExcel()" :disabled="activeExportBtn == false"></gofix-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
        <hr/>
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @row-click="openModalEdit"
            @load-items="getTableData"
            ref="gofixTable">
            <template slot="gofix_table:average_score" slot-scope="row">
                {{ `${row.item.average_score}%` }}
            </template>
            <!-- <template slot="gofix_table:adjust" slot-scope="row">
                {{ `${row.item.adjust}%` }}
            </template> -->
            <template slot="gofix_table:adjust" slot-scope="row">
                <!-- <span class="fakeInput text-center" style="width: 100px; float: right;"> {{ `${row.item.adjust}%` }} </span> -->
                {{ `${row.item.adjust}%` }}
            </template>
            <template slot="gofix_table:final_score" slot-scope="row">
                {{ `${row.item.final_score}%` }}
            </template>
            <template slot="gofix_table:deduction" slot-scope="row">
                {{ `${row.item.deduction}%` }}
            </template>
            <template slot="gofix_table:percent_payment_to_cv" slot-scope="row">
                {{ `${row.item.percent_payment_to_cv}%` }}
            </template>
            <template slot="gofix_table:payment_to_cv" slot-scope="row">
                {{ row.item.payment_to_cv | formatMoney }}
            </template>
            <template slot="gofix_table:less_rates_of_deduction" slot-scope="row">
                {{ row.item.less_rates_of_deduction | formatMoney }}
            </template>
        </gofix-table>
        <ModalFinalReport
            v-model="modals.open"
            title="Final Reports"
            :dataTable="modals.dataTable"
            :dataParam="modals.dataParam"
        />
        <b-modal
                :no-close-on-backdrop="true"
                id="modal-Create"
                :title="modalsAdjust.edit.title"
                hide-footer
                :centered="true"
                v-model="modalsAdjust.edit.open">
            <div>
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-input-number
                                label="Adjust (No)"
                                thousandsSeparatorSymbol=""
                                :includeThousandsSeparator="false"
                                v-model="modalsAdjust.edit.data.adjust"
                                allowNegative
                            />
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="text-right d-block">
                    <gofix-button label="Save" :loading="modalsAdjust.edit.loading" @click="saveDrafDataEntry" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
    </gofix-card>
</template>
<script>
import moment from 'moment';
import ModalFinalReport from './modal-final-report.vue';
export default {
    name: 'final-report',
    components: {
        ModalFinalReport
    },
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        return {
            tableConfig:{
                name: 'table-final-report',
                controls:{
                    create: false,
                    update: false,
                    delete: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    reload: false,
                    tablePagination: false,
                    tableFilter: false
                },
                filter: { },
                page: 1,
                limit: 100,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'location_name',
                        label: 'Division',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left'
                    },
                    {
                        key: 'average_score',
                        label: 'Average Score',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'adjust',
                        label: 'Adjustment',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'final_score',
                        label: 'Final Score',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'deduction',
                        label: 'Deduction',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'percent_payment_to_cv',
                        label: 'Payment to CV (%)',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'less_rates_of_deduction',
                        label: 'Rates of Deduction',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'payment_to_cv',
                        label: 'Payment to CV ($)',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            supplier_contract: '',
            locations: [],
            location: '',
            property_types: ['Residential', 'Hawker Centre'],
            property_type: 'Residential',
            years: [],
            year: '',
            months: [],
            month: '',
            timer: null,
            loading: false,
            activeExportBtn: false,
            modals: {
                open: false,
                title: 'Final Export',
                dataTable: [],
                dataParam: {},
            },
            activeSaveBtn: false,
            modalsAdjust: {
                edit : {
                    open: false,
                    loading: false,
                    title: "Edit Adjust	",
                    data: {
                        adjust: null,
                        index: 0
                    },
                },
                comfirmReload: {
                    open:false,
                    loading: false,
                    data: []
                }
            },
        }
    },
    watch: {
        ClientContractID: function(val) {
            this.getSupplierContract(null, true); 
        },
        "supplier_contract": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "location": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "property_type": function(val) {
           this.$refs.gofixTable.reloadTableItems();
        },
        "month": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "year": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
    },
    created() {
        this.getInitData()
        this.getSupplierContract(null, true);
    },
    filters: {
        highlightNode(val, option_selected) {
            if(option_selected) {
                if(option_selected.name) {
                    val = val.replace(option_selected.name, `<span class="d-inline font-weight-bold">${option_selected.name}</span>`);
                } else {
                    let regex = new RegExp(option_selected, "i");
                    let index = val.search(regex);
                    let substr = val.substr(index, option_selected.length);
                    val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                }
            }

            return val;
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();
            
            if ( !this.supplier_contract ) {
                this.activeExportBtn = false
                const response = {
                    items: [],
                    total: 0
                }
                resolve(response);
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                return;
            }

            tableRequest.month = this.month
            tableRequest.year = this.year
            tableRequest.contract_id = this.supplier_contract.id
            tableRequest.property_type = this.property_type
            tableRequest.type = 'final report'
            tableRequest.is_download_pdf = false
            
            await this.$store.dispatch("PAConservancyController/getPAReport", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.modals.dataTable = response.items
                
                this.tableConfig.total = response.total;
                resolve(response);
                if(this.tableConfig.total != 0){
                    this.activeExportBtn = true
                }else{
                    this.activeExportBtn = false
                }
                this.modals.dataParam = {
                    month: this.month,
                    year: this.year,
                    contract_id: this.supplier_contract.id,
                    property_type: this.property_type,
                    type: 'final report',
                    is_download_pdf: true,
                };
            })
            .catch(err => { })
        },
        getInitData(){
            this.loadingData = true;
            var iYear = parseInt(moment().format('YYYY'));
            if(this.Year) this.year = this.Year;
            else this.year = iYear;
            
            for(var i=0;i<15;i++){
                this.years.push(iYear);
                iYear--;
            }
            this.month = moment().format('MM');
            this.populateMonthHeaders();
        },
        populateMonthHeaders(){
            var mTime = moment(this.year+"-"+"January"+"-"+"01","YYYY-MMMM-DD");
            var iMonth = 0;
            var iMonths = [];
            while(iMonth<12){
                var dTime = mTime.clone();
                dTime.add(iMonth,'month');
                iMonths.push({'text' : dTime.format('MMMM'), 'value' : dTime.format('MM')});
                iMonth++;
            }
            this.months = iMonths;
        },
        async getSupplierContract(search = null, is_set_default = false) {
            this.loading = true
            let tableRequest = {
                filter: {
                    contract_title: { type: "text", value: search, function: "ilike", with: [] },
                    contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : ""
                },
                limit: 100,
                page: 1,
                isCMS: 1,
                useDatabaseView: true,
                sortColumn: "contract_title",
                sortDirection: "ASC"
            }
            await this.$store.dispatch("ContractController/getListSContracts", tableRequest)
            .then(response => {
                this.location = null;
                this.locations = [];
                
                this.supplier_contracts = response.data.data.contracts
                
                if(is_set_default) {
                    this.supplier_contract = null
                    if(response.data.data.contracts[0]){
                        this.supplier_contract = response.data.data.contracts[0]
                    }
                }
                
                this.loading = false
            })
            .catch(err => {
                this.loading = false
            })
        },
        searchSupplierContract(search, loading){
            loading(true);
            this.supplier_contracts = []
            if(this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getSupplierContract(search);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        async exportReport() {
            let getParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                type: 'final report',
                is_download_pdf: true,
            };

            await this.$store.dispatch("PAConservancyController/exportInterimReportReport", getParam)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'interim-report-' + this.month + '-' + this.year + '.pdf');
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => { })
        },
        async exportFinalReport() {
            // this.modals.open = true;

            this.activeExportBtn = false

            let getParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                type: 'final report',
                is_download_pdf: true,
            };

            await this.$store.dispatch("PAConservancyController/exportInterimReportReport", getParam)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'final-report-' + this.month + '-' + this.year + '.pdf');
                document.body.appendChild(link);
                link.click();
                this.activeExportBtn = true
            })
            .catch(err => {
                this.activeExportBtn = true
            })
        },
        openModalEdit(item,index){
            return;
            this.modalsAdjust.edit.title = item.location_name;
            this.modalsAdjust.edit.data.adjust = item.adjust || null
            this.modalsAdjust.edit.data.index = index
            this.modalsAdjust.edit.open = true
        },
        saveDrafDataEntry(){
            let adjust = parseInt(this.modalsAdjust.edit.data.adjust)

            if ( !adjust ) {
                adjust = 0;
            }
            if ( adjust > 100 ) {
                return this.$alertNotification("Total Adjust must be less than or equal to 100%", "danger")
            }

            // let index = this.modalsAdjust.edit.data.index
            // this.tableItems[index].adjust = adjust
            // this.tableItems[index].payment_to_cv = adjust + this.tableItems[index].average_score
            this.activeSaveBtn = true

            this.modalsAdjust.edit.loading = true;
            this.saveReport()
        },
        async saveReport() {
            let tableItems = JSON.parse(JSON.stringify(this.tableItems));
            if(this.modalsAdjust.edit.data.adjust !== null) {
                let index = this.modalsAdjust.edit.data.index
                tableItems[index].adjust = parseInt(this.modalsAdjust.edit.data.adjust)
            }
            let items = tableItems.map(function(item) {
                return {
                    property_id: item.location_id,
                    adjust: item.adjust
                }
            });

            this.loading = true
            let dataSave = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                items: items
            }

            await this.$store.dispatch("PAConservancyController/saveInterimReport", dataSave)
            .then(response => {
                this.$alertNotification("Successfully updated final report", "success");
                this.loading = false
                this.activeSaveBtn = false
                this.modalsAdjust.edit.loading = false;
                this.modalsAdjust.edit.open = false;
                this.$refs.gofixTable.reloadTableItems();
            })
            .catch(err => {
                if (err.response.data.error && err.response.data.error.message) {
                    this.$alertNotification(err.response.data.error.message, "danger")
                }
                this.loading = false
            })
        },
        async exportExcel() {
            
            let getNewParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                type: 'final report',
            };

            await this.$store.dispatch("PAConservancyController/exportFinalReportExcel", getNewParam)
            .then(response => {
                let nameFile = 'Final_Report.xlsx';
                if(response.headers["content-disposition"]) {
                  let arrTemp = response.headers["content-disposition"].split("filename=");
                  if(arrTemp[1]) {
                    nameFile = arrTemp[1].replaceAll('"', "");
                  }
                }

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nameFile);
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => { })
        },
    }
}
</script>